const initialState = {
  companies: {
    data: [],
    loading: false,
    error: null,
    total: 0,
  },
  addNewCompany: {
    data: {},
    loading: false,
    error: null,
  },
  editCompany: {
    data: {},
    loading: false,
    error: null,
  },
};

export default initialState;
